import { ref } from "vue";

const state = ref({} as any);

export default function keycloakStore(): any {
  function setKeycloakData(data: any) {
    console.debug("setKeycloakData", data);
    state.value.keycloakData = data;
  }

  function getKeycloakData() {
    return state.value.keycloakData;
  }

  function getKeycloakAccessToken() {
    return state?.value?.keycloakData?.token;
  }

  function getVermittlerNummern() {
    return state?.value?.keycloakData?.tokenParsed?.VermittlerNummern;
  }

  function hatEineRolle(rollen: string[]) {
    for (const rolle of rollen) {
      if (state?.value?.keycloakData?.hasRealmRole(rolle)) {
        return true;
      }
    }
    return false;
  }

  return {
    setKeycloakData,
    getKeycloakData,
    getKeycloakAccessToken,
    getVermittlerNummern,
    hatEineRolle,
  };
}
